// **WARNING** Do not modify this file. It generates actions based on the actionTypes constants in ./constants
const snakeToCamel = string => string.toLocaleLowerCase().replace(/_(\w)/g, (m => m[1].toUpperCase()));
export default (constants, custom = {}) => Object.keys(constants.actionTypes).reduce((acc, type) => ({
    ...acc,
    [snakeToCamel(type)]: Object.keys(constants.actionTypes[type]).reduce((actions, action) => ({
        ...actions,
        [snakeToCamel(action)]: function(args = {}) { return ({ ...args, type: constants.actionTypes[type][action] }); }
    }), {})
}), {});